// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1JE5U","notes":"Notes_notes__1T_ZV"};